require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-which-class-is-right-for-you-this-question-and-more-answered-during-online-q-a.json") })
        }
      }, "path---blog-which-class-is-right-for-you-this-question-and-more-answered-during-online-q-a");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-which-class-is-right-for-you-this-question-and-more-answered-during-online-q-a!./.cache/json/blog-which-class-is-right-for-you-this-question-and-more-answered-during-online-q-a.json
// module id = 1147
// module chunks = 231608221292675